export enum Apps {
  BLOG_WRITER = 'BLOG_WRITER',
  EMAIL_GENERATOR = 'EMAIL_GENERATOR',
  CHAT_WITH_DOCS = 'CHAT_WITH_DOCS',
  TEXT_TO_IMAGE = 'TEXT_TO_IMAGE',
  IMAGE_TO_IMAGE = 'IMAGE_TO_IMAGE',
  TEXT_TO_LOGO = 'TEXT_TO_LOGO',
  STICKER_MAKER = 'STICKER_MAKER',
  GIF_MAKER = 'GIF_MAKER',
  TRANSCRIPT_GENERATOR = 'TRANSCRIPT_GENERATOR',
  TEXT_TO_SPEECH = 'TEXT_TO_SPEECH',
  UPSCALE_IMAGE = 'UPSCALE_IMAGE',
  OBJECT_REMOVER = 'OBJECT_REMOVER',
  OBJECT_REPLACER = 'OBJECT_REPLACER',
  BOT_BUILDER = 'BOT_BUILDER',
  BRANDBOOK = 'BRANDBOOK',
  PODCAST = 'PODCAST',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
}
